function getWeekMonday(dateInput) {
  let date

  if (!dateInput) date = new Date()
  else if (dateInput instanceof Date && !isNaN(dateInput)) date = new Date(dateInput)
  else if (typeof dateInput === 'string') {
    // Ensure date string is parsed as local date, not UTC
    const parts = dateInput.split('T')[0].split('-'),
      year = parseInt(parts[0], 10),
      month = parseInt(parts[1], 10) - 1, // 0-based month
      day = parseInt(parts[2], 10)
    date = new Date(year, month, day)
  }

  // At this point, `date` is guaranteed to be a local Date object
  const monday = new Date(date)
  let dayOfWeek = monday.getDay()

  // Adjust Sunday (0) to 7 so Monday stays start of the week
  if (dayOfWeek === 0) dayOfWeek = 7

  // Subtract (day - 1) to get to Monday
  monday.setDate(monday.getDate() - (dayOfWeek - 1))
  monday.setHours(0, 0, 0, 0)

  return monday
}

export { getWeekMonday }
